import { getMetarIcon } from '../icons.js';
import { convertTemperature, convertDirection, convertMsToMph, convertToTime } from '../helpers.js';


const renderNDFDHourly = (forecast) => {

  forecast.ndfd_hourly.data.forEach((data, fhr) => {
    // Start at forecast hour (fhr) 1 because the retrieveMETAR function handles fhr00
    // fhr += 1;
    // Add leading '0' to each hour of the forecast below hour 10 (e.g. 1 -> 01, 2 -> 02, etc.)
    fhr = fhr.toString().padStart(2, '0')

    // Is it daytime or nighttime?
    // Returns true if it's daytime or false if it's nighttime
    const isDaytime = data.daylight

    document.getElementById(`nws-hour-${fhr}`).innerHTML = convertToTime(data.valid_begin).withoutMins
    document.getElementById(`nws-icon-${fhr}`).setAttribute('src', getMetarIcon(data.weather_code.value, isDaytime));
    document.getElementById(`nws-phrase-${fhr}`).innerHTML = data.weather_code.text;
    document.getElementById(`nws-temp-${fhr}`).innerHTML = `${convertTemperature(data.temperature.value).fahrenheit}&deg;`;
    document.getElementById(`nws-pop-${fhr}`).innerHTML = `${data.precipitation.probability.value}%`;
    document.getElementById(`nws-wind-${fhr}`).innerHTML = `${ convertDirection(data.wind.dir).short } ${ convertMsToMph(data.wind.speed) }`;
  })
};

export { renderNDFDHourly };